import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { SwaggerService } from 'app/providers/api/services';
import { useApiQuery } from 'shared/hooks/useApiQuery';

const useIntegrationSellerDocsPage = () => {
  const { sellerId } = useParams();
  const [sellerSwagger, setSellerSwagger] = useState<any>(null);

  const domain = window.location.hostname;
  const outboundApiUrl =
    domain === 'localhost'
      ? 'http://localhost:8004'
      : `https://gnrc.${domain.replace('seller.', '')}`;

  const { data: swaggerData, isLoading } = useApiQuery(
    ['getSellerSwagger'],
    () => SwaggerService.fetchOutboundSwagger(outboundApiUrl),
    {
      staleTime: Infinity,
      cacheTime: 30 * 60 * 1000,
    },
  );

  useEffect(() => {
    if (swaggerData) {
      setSellerSwagger(swaggerData);
    }
  }, [swaggerData]);

  return {
    sellerId,
    isLoading,
    sellerSwagger,
  };
};

export default useIntegrationSellerDocsPage;
